import { z, ZodType } from 'zod';

export type Voucher = {
	id: number;
	currency: string;
	currentCount: number;
	totalCount: number;
	deposit: number;
	wagering: number;
	isLocked: boolean;
	createdAt: string;
};

export const voucherSchema: ZodType<Voucher> = z.object({
	id: z.number(),
	currency: z.string(),
	currentCount: z.number(),
	totalCount: z.number(),
	deposit: z.number(),
	wagering: z.number(),
	isLocked: z.boolean(),
	createdAt: z.string(),
});
